import {lazy} from 'react';

const Gongchuang = lazy(() => import('@/modules/gongchuang'));
const Welcomeh5 = lazy(() => import('@/modules/welcomeh5'));
const Recommendation = lazy(() => import('@/modules/recommendation'));
const AiTemplate = lazy(() => import('@/modules/aiTemplate'));
// 特效H5
const ActAI = lazy(() => import('@/modules/actAI'));
const actAIList = lazy(() => import('@/modules/actAI/list'));
const ActAICreate = lazy(() => import('@/modules/actAI/create'));
const DigitalAvatar = lazy(() => import('@/modules/digitalAvatar'));
const DigitalAvatarCreate = lazy(() => import('@/modules/digitalAvatar/create'));
// 活动页面
const NewYear2025 = lazy(() => import('@/modules/activity/newYear2025'));
const NewYear2026 = lazy(() => import('@/modules/activity/newYear2026'));
const GaoKao2025 = lazy(() => import('@/modules/activity/gaokao2025'));
const MayDay = lazy(() => import('@/modules/activity/mayDay'));
const DraftList = lazy(() => import('@/modules/activity/draftList'));
const Summer = lazy(() => import('@/modules/activity/summer'));
const ugcCreator = lazy(() => import('@/modules/activity/ugcCreator'));
const ugcCreatorList = lazy(() => import('@/modules/activity/ugcCreator/list'));
const ugcCreatorRank = lazy(() => import('@/modules/activity/ugcCreator/rank'));
// AI玩法
const AiBless = lazy(() => import('@/modules/aiCreate/pages/bless'));
const HighLight = lazy(() => import('@/modules/aiCreate/pages/highLight'));
const HighLightVideo = lazy(() => import('@/modules/aiCreate/pages/highLightVideo'));
const AiPK = lazy(() => import('@/modules/aiCreate/pages/pk'));
const PkViewPoint = lazy(() => import('@/modules/aiCreate/pages/pkViewPoint'));
const AiPoem = lazy(() => import('@/modules/aiCreate/pages/poem'));
const AiCouplet = lazy(() => import('@/modules/aiCreate/pages/couplet'));
const WealthGod = lazy(() => import('@/modules/aiCreate/pages/wealthGod'));
const LootFu = lazy(() => import('@/modules/aiCreate/pages/lootFu'));
const Lantern = lazy(() => import('@/modules/aiCreate/pages/lantern'));
const GoldenTree = lazy(() => import('@/modules/aiCreate/pages/goldenTree'));
const AiPartner = lazy(() => import('@/modules/aiPartner'));
const AiPlay = lazy(() => import('@/modules/aiPlay'));
const HaokanPlay = lazy(() => import('@/modules/haokanPlay'));
// app内H5页面
const CitySelect = lazy(() => import('@/modules/appPage/CitySelect'));
const TiebaSelect = lazy(() => import('@/modules/appPage/TiebaSelect'));
const WorkData = lazy(() => import('@/modules/appPage/workData'));
// 分享回流
const ShareActAI = lazy(() => import('@/modules/share/actAI'));
const Editor = lazy(() => import('@/modules/appPage/editor'));
// 敏捷问卷卡片
const Research = lazy(() => import('@/modules/research'));

const routes = [
    {
        path: '/campaign/gongchuang',
        Component: Gongchuang,
    },
    {
        path: '/campaign/welcomeh5',
        Component: Welcomeh5,
    },
    {
        path: '/campaign/actAI',
        Component: ActAI,
    },
    {
        path: '/campaign/actAI/list',
        Component: actAIList,
    },
    {
        path: '/campaign/actAICreate',
        Component: ActAICreate,
    },
    {
        path: '/h5/digital-avatar',
        Component: DigitalAvatar,
    },
    {
        path: '/h5/digital-avatar/create',
        Component: DigitalAvatarCreate,
    },
    {
        path: '/h5/inspiration/rec',
        Component: Recommendation,
    },
    {
        path: '/h5/inspiration/aiTpl',
        Component: AiTemplate,
    },
    {
        path: '/h5/activity/new-year-2025',
        Component: NewYear2025,
    },
    {
        path: '/h5/activity/new-year-2026',
        Component: NewYear2026,
    },
    {
        path: '/h5/activity/mayday',
        Component: MayDay,
    },
    {
        path: '/h5/activity/draft-list',
        Component: DraftList,
    },
    {
        path: '/h5/activity/summer',
        Component: Summer,
    },
    {
        path: '/h5/activity/creator',
        Component: ugcCreator,
    },
    {
        path: '/h5/activity/creator/list',
        Component: ugcCreatorList,
    },
    {
        path: '/h5/activity/creator/rank',
        Component: ugcCreatorRank,
    },
    {
        path: '/h5/activity/gk2025',
        Component: GaoKao2025,
    },
    {
        path: '/h5/bless',
        Component: AiBless,
    },
    {
        path: '/h5/ai-create/highlight',
        Component: HighLight,
    },
    {
        path: '/h5/ai-create/highlight-video',
        Component: HighLightVideo,
    },
    {
        path: '/h5/ai-create/pk',
        Component: AiPK,
    },
    {
        path: '/h5/ai-create/pk-viewpoint',
        Component: PkViewPoint,
    },
    {
        path: '/h5/ai-create/poem',
        Component: AiPoem,
    },
    {
        path: '/h5/ai-create/couplet',
        Component: AiCouplet,
    },
    {
        path: '/h5/ai-create/wealthgod',
        Component: WealthGod,
    },
    {
        path: '/h5/ai-create/lantern',
        Component: Lantern,
    },
    {
        path: '/h5/ai-create/lootFu',
        Component: LootFu,
    },
    {
        path: '/h5/ai-create/golden-tree',
        Component: GoldenTree,
    },
    {
        path: '/h5/ai-partner',
        Component: AiPartner,
    },
    {
        path: '/h5/ai-play', // 拍福气
        Component: AiPlay,
    },
    {
        path: '/h5/ai-play-haokan',
        Component: HaokanPlay,
    },
    {
        path: '/h5/research',
        Component: Research,
    },
    {
        path: '/h5/app-page/city-select',
        Component: CitySelect,
    },
    {
        path: '/h5/app-page/tieba-select',
        Component: TiebaSelect,
    },
    {
        path: '/h5/app-page/work-data',
        Component: WorkData,
    },
    {
        path: '/h5/share/actAI',
        Component: ShareActAI,
    },
    {
        path: '/h5/app-page/editor',
        Component: Editor,
    },
];

export default routes;
